export default "__VITE_ASSET__BXqhS7vB__"